<template>
    <navigation :pushUserButtons="false" :loginForm="showLoginForm" @loginFormClose="showLoginForm=false">
        <template #prelogo v-if="uiStore.backButtonCount">
            <a href="#" class="px-1 px-md-2 d-flex align-items-center me-1" @click.prevent="goBack"><left-arrow-icon :size="14" /></a>
        </template>
        <template v-if="isDesktop && !uiStore.checkOutFlow" #default>
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                <li class="nav-item pe-5">
                    <main-menu-link to="/book-a-property">
                        Book a Property
                    </main-menu-link>
                </li>
                <li class="nav-item pe-5" ref="servicesDesktopMenu" @click.stop>
                    <a href="#" @click.prevent="toggleMenu" class="nav-link">
                        Services
                        <down-pointer-icon :size="12" class="ms-2 rotate" :class="uiStore.desktopMenuOpen ? 'rotate-180' : null" />
                    </a>
                    
                </li>
            </ul>
            <teleport v-if="hasMainHeader" to="#main-header">
                <transition name="v-slide-transition-4">
                    <div v-if="uiStore.desktopMenuOpen" class="position-absolute top-100 start-0 end-0 bg-body py-3 border-bottom border-top">
                        <div :style="`margin-left:${serviceMenuLeft};`" @click.stop="delayHideMenu">

                            <router-link v-for="(serviceLink, index) in serviceLinks" :key="`desktop-service-link-${index}`" :to="serviceLink.route" class="box-link mb-2 d-flex align-items-center main-menu-drop-down-link" :class="(activeRoute == serviceLink.route) ? 'active' : null">
                                <div class="flex-shring-0" style="width:20px;">
                                    <next-arrow-icon v-if="activeRoute == serviceLink.route" :size="10"/>
                                </div>
                                {{ serviceLink.label }}
                            </router-link>
                        </div>
                    </div>
                </transition>
            </teleport>
        </template>
        <template v-else-if="!uiStore.checkOutFlow" #default>
            <div class="d-flex flex-column justify-content-between" style="min-height: 100%;" @click="hideExtraMenu">
                <div>
                    <list-group :flush="true" class="border-bottom">
                        <list-group-item class="fs-4 pb-3 pt-3" to="/book-a-property">
                            Book a Property
                        </list-group-item>
                        <list-group-item class="fs-4 pb-3 pt-3 d-flex justify-content-between align-items-center" :action="() => servicesMenuOpen = !servicesMenuOpen">
                            <span>Services</span>
                            <svg-plus-sign style="transition:transform 0.2s;" :style="servicesMenuOpen ? 'transform: rotate(-45deg);' : null"/>
                        </list-group-item>
                        <transition name="v-slide-transition-6">
                            <list-group-item class="pb-3 pt-3" v-if="servicesMenuOpen">
                                <main-menu-link v-for="(serviceLink, index) in serviceLinks" :key="`mobile-service-link-${index}`" :to="serviceLink.route" class="py-1 text-primary position-relative">
                                    <next-arrow-icon v-if="activeRoute == serviceLink.route" :size="10" class="position-absolute" style="left:-15px; top:12px;"/>
                                    {{ serviceLink.label }}
                                </main-menu-link>
                            </list-group-item>
                        </transition>
                        <template v-if="authStore.loggedInUser">
                            <list-group-item class="fs-4 pb-3 pt-3 d-flex justify-content-between align-items-center" :action="() => myAccountMenuOpen = !myAccountMenuOpen">
                                <span>My Account</span>
                                <svg-plus-sign style="transition:transform 0.2s;" :style="myAccountMenuOpen ? 'transform: rotate(-45deg);' : null"/>
                            </list-group-item>
                            <transition name="v-slide-transition-6">
                                <list-group-item class="pb-3 pt-3" v-if="myAccountMenuOpen">
                                    <main-menu-link :to="profileLink" class="py-1 text-primary">
                                        My Profile
                                    </main-menu-link>

                                    <main-menu-link to="/travelers" class="py-1 text-primary">
                                        Travelers Account
                                    </main-menu-link>

                                    <main-menu-link v-for="(portal, index) in portals" :key="`users-public-nav-portal-${index}`" :to="portal.url" class="py-1 text-primary">
                                        {{ portal.label }}
                                    </main-menu-link>

                                    <a href="#" class="nav-link py-1 text-primary" @click.prevent="logout">
                                        Logout
                                    </a>
                                </list-group-item>
                            </transition>
                        </template>
                        <list-group-item v-else class="fs-4 pb-3 pt-3" @click="showLoginForm=true">
                            Sign Up / Login
                        </list-group-item>
                        
                    </list-group>

                    <div class="mt-3 ps-3 mb-4">
                        <main-menu-link to="/about" class="py-1 text-primary">About Us</main-menu-link>
                        <main-menu-link to="/blog" class="py-1 text-primary">Blog</main-menu-link>
                        <main-menu-link to="/press" class="py-1 text-primary">Press</main-menu-link>
                    </div>
                </div>

                <div class="my-2">
                    <main-menu-link to="/contact" class="ps-3"><i class="fas fa-envelope"></i> Contact Us</main-menu-link>
                    <hr class="mt-2" />
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <a href="mailto:info@staymarquis.com">
                                info@staymarquis.com
                            </a>
                        </div>
                        <social-media-icons/>
                    </div>

                    <hr />
                    <div class="small text-muted d-flex justify-content-between">
                        <div>
                            &copy; StayMarquis {{ year }}
                        </div>
                        <div>
                            <main-menu-link to="/terms/privacy-policy" class="d-inline">Privacy Policy</main-menu-link>
                            &nbsp;|&nbsp;
                            <main-menu-link to="/terms" class="d-inline">Terms of Use</main-menu-link>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-if="isDesktop && !uiStore.checkOutFlow" #endMenu>
            <ui-button color="white" @click="showExtraMenu" aria-label="Main Menu" class="d-inline-flex align-items-center">
                <menu-icon :size="20"/>
            </ui-button>

            <peek :open="extraMenuOpen" v-if="isDesktop" @close="hideExtraMenu" :addBorder="true">
                
                <template #default>
                    <div class="d-flex flex-column justify-content-between" style="min-height: 100%;" @click="hideExtraMenu">
                        <list-group :flush="true" class="border-bottom">
                            <list-group-item class="fs-4 pb-3 pt-3" to="/about">
                                About Us
                            </list-group-item>
                            <list-group-item class="fs-4 pb-3 pt-3" to="/blog">
                                Blog
                            </list-group-item>
                            <list-group-item class="fs-4 pb-3 pt-3" to="/press">
                                Press
                            </list-group-item>
                            <list-group-item class="fs-4 pb-3 pt-3" to="/contact">
                                Contact Us
                            </list-group-item>
                        </list-group>

                        <social-media-icons class="my-2 text-muted text-center"/>
                    </div>
                </template>
            </peek>
        </template>
    </navigation>
</template>
<script type="text/javascript">
    import Navigation from '@/components/Layout/Navigation.vue';
    import MainMenuLink from '@/components/Layout/MainMenuLink.vue';
    import CommonComponents from '@/components/Common.vue';
    import SocialMediaIcons from '@/components/Content/SocialMediaIcons.vue';
    import SvgPlusSign from '@/assets/icons/plus-sign.svg.vue';
    import LeftArrowIcon from '@/assets/icons/left-arrow.svg.vue';
    import DownPointerIcon from '@/assets/icons/down-pointer.svg.vue';
    import NextArrowIcon from '@/assets/icons/next-arrow.svg.vue';
    import MenuIcon from '@/assets/icons/menu.svg.vue';

    import { UseUIStore } from '@/store/UI.js';
    import { UseAuthStore } from '@/store/Auth.js';

    export default {

        components: {
            MainMenuLink,
            Navigation,
            SocialMediaIcons,
            SvgPlusSign,
            LeftArrowIcon,
            DownPointerIcon,
            NextArrowIcon,
            MenuIcon,
            ...CommonComponents
        },

        setup() {
            return {
                uiStore: UseUIStore(),
                authStore: UseAuthStore(),
            };
        },

        data() {
            return {
                extraMenuOpen: false,
                servicesMenuOpen: false,
                myAccountMenuOpen: false,
                serviceMenuLeft: '65%',
                checkForMainHeader: 1, // counter to check if the main header is ready
                year: (new Date().getFullYear()),
                showLoginForm: false,

                serviceLinks: [
                    {
                        route: '/list-your-property',
                        label: 'Rent Your Home',
                    },
                    {
                        route: '/property-management',
                        label: 'Manage Your Home',
                    },
                    {
                        route: '/real-estate',
                        label: 'Buy a Home',
                    },
                    {
                        route: '/renovate',
                        label: 'Renovate Your Home',
                    },
                ]
            };
        },

        computed: {
            isDesktop() {
                if (this.uiStore.isMobile || this.uiStore.isTablet) {
                    return false;
                }
                return true;
            },

            portals() {
                let portals = [];
                if (
                    (this.authStore.loggedInUser) &&
                    (this.authStore.loggedInUser.portalsData) &&
                    (this.authStore.loggedInUser.portalsData.length)
                ) {
                    for (let i=0; i<this.authStore.loggedInUser.portalsData.length; i++) {
                        if (
                            (!this.authStore.loggedInUser.portalsData[i].usersApp) ||
                            (this.authStore.loggedInUser.portalsData[i].name == this.uiStore.appPortal)
                        ) {
                            continue;
                        }

                        portals.push(this.authStore.loggedInUser.portalsData[i]);
                    }
                }

                return portals;
            },

            profileLink() {
                if ((this.uiStore.homePageLink) && (this.uiStore.homePageLink != '/')) {
                    return `${this.uiStore.homePageLink}/profile`;
                }
                
                return '/travelers/profile';
            },

            activeRoute() {
                if (
                    (this.$route) && 
                    (this.$route.path)
                ) {
                    return this.$route.path;
                }
                return null;
            },

            hasMainHeader() {
                if ((this.checkForMainHeader) && (document.getElementById('main-header'))) {
                    return true;
                }
                this.waitForMainHeader();
                return false;
            },
        },

        methods: {
            async logout() {
                let loggedOut = await this.authStore.logout();
                if (loggedOut) {
                    this.$router.push('/');
                }
            },

            goBack() {
                this.$router.back();
            },
            
            showExtraMenu() {
                this.extraMenuOpen = true;
            },

            hideExtraMenu() {
                this.extraMenuOpen = false;
            },

            toggleMenu() {
                let left = '65%';
                if (this.$refs.servicesDesktopMenu) {
                    left = this.$refs.servicesDesktopMenu.getBoundingClientRect().left+'px';
                }
                this.serviceMenuLeft = left;
                this.uiStore.desktopMenuOpen = !this.uiStore.desktopMenuOpen;
            },

            delayHideMenu() {
                setTimeout(function() {
                    this.uiStore.desktopMenuOpen = false;
                }.bind(this), 120);
            },

            waitForMainHeader() {
                requestAnimationFrame(function() {
                    this.checkForMainHeader++;
                }.bind(this));
            },
        }

    };

</script>